"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentAdapterSafetyPay = void 0;

var __1 = require("..");

var Interfaces_1 = require("../Interfaces");

var interface_adapter_1 = require("../Interfaces/interface.adapter");

var PaymentAdapterSafetyPay =
/** @class */
function (_super) {
  __extends(PaymentAdapterSafetyPay, _super);

  function PaymentAdapterSafetyPay(env, vendorSessionInfo, billingContactInfo) {
    var _this = _super.call(this) || this;

    _this.vendorName = interface_adapter_1.PaymentVendors.safetypay;
    _this.env = env;
    _this.vendorSessionInfo = vendorSessionInfo;
    _this.billingContactInfo = billingContactInfo;
    return _this;
  }

  PaymentAdapterSafetyPay.prototype.encryptCreditCardData = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        throw new __1.PaymentClientError('Payment Method is not supported', Interfaces_1.PaymentErrorShortCodes.unsupported_payment_method);
      });
    });
  };

  PaymentAdapterSafetyPay.prototype.encryptACHData = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        throw new __1.PaymentClientError('Payment Method is not supported', Interfaces_1.PaymentErrorShortCodes.unsupported_payment_method);
      });
    });
  };

  PaymentAdapterSafetyPay.prototype.initializeWebDropIn = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        throw new __1.PaymentClientError('Payment Method is not supported', Interfaces_1.PaymentErrorShortCodes.unsupported_payment_method);
      });
    });
  };

  PaymentAdapterSafetyPay.prototype.initializeWebComponent = function (divId, paymentMethod) {
    return __awaiter(this, void 0, void 0, function () {
      var isSafetyPayPaymentMethod, safetypaySession_1, paymentDiv, safetypayForm_1, urlParams, tokenId, countryId, channelId, paymentButton, e_1;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            isSafetyPayPaymentMethod = paymentMethod === Interfaces_1.PaymentMethod.webComponentBoleto || paymentMethod === Interfaces_1.PaymentMethod.webComponentBankTransfer || paymentMethod === Interfaces_1.PaymentMethod.webComponentCash;

            if (!isSafetyPayPaymentMethod) {
              throw new __1.PaymentClientError('Payment Method is not supported', Interfaces_1.PaymentErrorShortCodes.unsupported_payment_method);
            }

            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , this.getDecodedVendorSessionPayload()];

          case 2:
            safetypaySession_1 = _a.sent();
            paymentDiv = document.getElementById(divId);

            if (!paymentDiv) {
              throw new Error('Cannot find element with the provided divId: ' + divId);
            }

            safetypayForm_1 = document.createElement('form');
            safetypayForm_1.id = 'safetypayPaymentFormId-' + Math.random().toString(36).substring(6);
            paymentDiv.appendChild(safetypayForm_1);
            urlParams = new URLSearchParams(safetypaySession_1.vendorPaymentUrl.split('?')[1]);
            tokenId = urlParams.get('TokenID');
            countryId = urlParams.get('CountryID');
            channelId = urlParams.get('ChannelID');
            if (tokenId) this.addInputToForm(safetypayForm_1, 'TokenID', tokenId);
            if (countryId) this.addInputToForm(safetypayForm_1, 'CountryID', countryId);
            if (channelId) this.addInputToForm(safetypayForm_1, 'ChannelID', channelId);
            paymentButton = document.createElement('button');
            paymentButton.innerHTML = 'Pay Now';

            paymentButton.onclick = function () {
              return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  //direct to the paymentUrl
                  safetypayForm_1.action = safetypaySession_1.vendorPaymentUrl;
                  safetypayForm_1.submit();
                  return [2
                  /*return*/
                  ];
                });
              });
            };

            paymentDiv.appendChild(paymentButton);
            return [3
            /*break*/
            , 4];

          case 3:
            e_1 = _a.sent();
            throw new __1.PaymentClientError('Error creating web component: ' + e_1.message, Interfaces_1.PaymentErrorShortCodes.server_session_error, {
              vendorName: this.vendorName,
              cause: {
                message: e_1.message,
                details: JSON.stringify(e_1)
              }
            });

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  PaymentAdapterSafetyPay.prototype.addInputToForm = function (form, name, value) {
    var input = document.createElement('input');
    input.name = name;
    input.value = encodeURIComponent(value);
    input.type = 'hidden';
    form.appendChild(input);
  };

  return PaymentAdapterSafetyPay;
}(interface_adapter_1.PaymentAdapter);

exports.PaymentAdapterSafetyPay = PaymentAdapterSafetyPay;